<template>
  <div>
    <Head :title="`${form.first_name} ${form.last_name}`" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1>{{ form.first_name }} {{ form.last_name }}</h1>
    </div>
    <trashed-message v-if="user.deleted_at" class="mb-6" @restore="restore"> This user has been deleted. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="formrow" label="First name" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="formrow" label="Last name" />
          <text-input v-model="form.email" :error="form.errors.email" class="formrow" label="Email" />
          <text-input v-model="form.password" :error="form.errors.password" class="formrow" type="password" autocomplete="new-password" label="Password" />
          <select-input v-if="auth.user.owner" v-model="form.owner" :error="form.errors.owner" class="formrow" label="Owner">
            <option :value="true">Yes</option>
            <option :value="false">No</option>
          </select-input>

          <div class="formrow">
            <button v-if="!user.deleted_at" class="btn" tabindex="-1" type="button" @click="destroy">Delete User</button>
            <loading-button :loading="form.processing" class="btn" type="submit">Update User</loading-button>
          </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    user: Object,
    auth: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        password: '',
        owner: this.user.owner,
        photo: null,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/users/${this.user.id}`, {
        onSuccess: () => this.form.reset('password', 'photo'),
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this user?')) {
        this.$inertia.delete(`/users/${this.user.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this user?')) {
        this.$inertia.put(`/users/${this.user.id}/restore`)
      }
    },
  },
}
</script>
